import { Box, Typography } from "@mui/material";
import { ColDef } from "ag-grid-community";
import { forwardRef, Ref, type JSX } from "react";
import { systemBalanceComparator } from "../../../components/ag-grid-extensions/comparators/SystemBalanceComparator";
import { GridData } from "../../../components/ag-grid-extensions/models/GridData";
import { RowDef } from "../../../components/ag-grid-extensions/models/RowDef";
import SummaryListingGrid from "../../../components/summary-listing-grid/SummaryListingGrid";
import { useUserContext } from "../../../contexts/user-context/UserContext";
import { postSortByOrder, postSortDevicesOnAlarms } from "../common/Common";
import { SummaryListingSortTypeEnum } from "../../../common/enums/SummaryListingSortTypeEnum";
import { DefaultGridRef } from "../../../components/default-grid/DefaultGrid";


export type SectionGridProps = {
    name: string;
    columnDefs: Array<ColDef>;
    rowData: Array<RowDef>;
    isSystemBalance: boolean;
    filterText: string;
    configurationID: number;
    showFooter?: boolean;
    fitToView?: boolean;

    card?: string;

    sortType?: SummaryListingSortTypeEnum;

    disableNavigation?: boolean;
    summaryListingOutletsFirst?: boolean;
    summaryListingAlarmAtTop: boolean;
};

//const maxRowSize = 25;

function SectionGrid({
    name,
    columnDefs,
    rowData,
    isSystemBalance,
    filterText,
    configurationID,
    fitToView,
    card,
    sortType,
    disableNavigation,
    summaryListingOutletsFirst,
    summaryListingAlarmAtTop
}: SectionGridProps, ref: Ref<DefaultGridRef>): JSX.Element {

    const [userState] = useUserContext();

    const gridData: GridData = {
        rows: rowData,
        cols: columnDefs
    };

    const maxRowSize = userState.userSettings?.gridRowCount ?? 25;

    const hasGridDataToDisplay = (rowData.filter(o => o.deviceName.toLowerCase().indexOf(filterText.trim().toLowerCase()) !== -1 || filterText === '').length ?? 0) > 0;    
    const paginate = !fitToView && gridData.rows.length > maxRowSize ? true : false;

    //console.log(`card ${card} section grid paginate: ${paginate} for ${name} rows: ${gridData.rows.length}`)

    return (

            <Box
                sx={{
                    display: hasGridDataToDisplay ? 'flex' : 'none',
                    flexDirection: "column",
                    flexGrow: fitToView ? 1 : 0,
                    flexShrink: fitToView ? 1 : 0,
                    //maxHeight: fitToView ? undefined : '800px',
                    marginTop: 1,
                    '& + &': {
                        marginTop: 1
                    }
                }}
                >

                   {(name?.length ?? 0) > 0 && <Typography variant="subtitle2" sx={{
                        padding: 1,
                        backgroundColor: "divider"
                    }}>
                        {name}
                    </Typography>
                    }


                <SummaryListingGrid
                    ref={ref}
                    show={true}
                    gridData={gridData}
                    showFooter={!isSystemBalance}
                    showGroupingFooter={isSystemBalance}
                    filterText={filterText}
                    postSort={sortType === SummaryListingSortTypeEnum.Custom ? 
                        postSortByOrder :
                        summaryListingAlarmAtTop 
                        ? postSortDevicesOnAlarms
                        : undefined
                    }
                    groupComparator={systemBalanceComparator(summaryListingOutletsFirst ?? false)}
                    configurationID={configurationID}
                    domLayout={fitToView ? 'normal' : 'autoHeight'}
                    isMultiSection={!fitToView}
                    pagination={paginate}
                    pageSize={!fitToView ? maxRowSize : undefined}
                    getRowId={data => data.data.deviceID.toString()}
                    disableNavigation={disableNavigation}
                />
            </Box>                                
        )

}

export default forwardRef<DefaultGridRef, SectionGridProps>(SectionGrid);

